<template lang="pug">
div
  v-card(:loading="busy")

    list-action-bar(
      v-bind="$props"
      @refresh="refresh"
      @perform="perform"
    )

    v-list.mb-3(
      v-for="(list, index) in lists"
      :key="`list-${index}`"
    )
      list-item(
        v-for="(item, index) in list"
        :key="`list-${index}-item-${index}`"
        v-bind="$props"
        :item="item"
        @perform="perform"
      )

  //- Diálogo de confirmação de operação
  action-dialog(
    v-bind="$props"
    :request="request"
    @actionComplete="refresh()"
    @actionTerminate="request = null"
  )
</template>

<style lang="scss">
@import '~@/plugins/vuetify/default-preset/preset/misc.scss';
</style>

<script>
import ActionDialog from '@/components/commons/action-dialog/ActionDialog'
import ActionBar from '@/components/commons/action-bar/ActionBar'
import ListActionBar from './ListActionBar'
import ListItem from './ListItem'
import { isLocked } from '@/helpers/entities'
import { hasRel } from '@/helpers/rels'
import { performAction } from '@/helpers/actions'
import { parseEref } from '@/helpers/erefs'

export default {
  components: {
    ActionDialog,
    ActionBar,
    ListActionBar,
    ListItem
  },

  props: {
    site: String,
    eref: String,
    form: Object,
    data: Object,
    entity: Object,

    busy: Boolean,
  },

  data: () => ({
    menu: true,

    /**
     * Registros selecionados na grade.
     * @type {Object}
     *    Format:
     *    {
     *      -- Link da requisição
     *      link: {Keep.Paper.Design.Link}
     *      -- Registros afetados pela requisição.
     *      selection: {Array}
     *    }
     */
    request: null, // Parâmetros de requisição
  }),

  computed: {
    title: vm => vm.entity?.title || vm.entity?.name || vm.entity?.eref,
    description: vm => vm.entity?.description,

    dataSet: vm => vm.entity?.dataSet?.sets?.[0],
    cols: vm => vm.dataSet?.headers || [],

    rows: vm => vm.dataSet?.rows || [],
    lists: vm => {
      let list1 = vm.rows.filter(row => hasRel(row, 'Primary'))
      let list2 = vm.rows.filter(row => hasRel(row, 'Secondary'))
      let list3 = vm.rows.filter(row => !list1.includes(row) && !list2.includes(row))
      let all = [ list1, list2, list3 ]
      return all.filter(list => list.length)
    },

    locked: vm => isLocked(vm.entity),
  },

  methods: {
    refresh () {
      this.$emit('refresh')
    },

    perform (opts) {
      const { selection } = opts
      const context = {
        site: this.site,
        eref: parseEref(this.eref),
        page: this.entity,
        data: this.data,
        // Se a seleção for um único registro então o usamos como linha afetada (row).
        row: Array.isArray(selection) ? null : selection
      }
      performAction(this, opts, context)

      // // TODO: FIXME: Substituir pelo novo: @/helpers/actions/performAction()
      // const link = opts.link
      // const rules = opts.link.rule || []
      // const browse = rules.some(rule => rule === 'Browse')
      // if (browse) {
      //   this.$go(link)
      //   } else {
      //   this.request = opts
      // }
    },
  }
}
</script>
